


// bags



(function () {
  var TARGET_PATH = '/collections/bags';

  // parsea "59", "59.00", "59,00"
  function toNum(v){
    if (v == null) return null;
    var n = parseFloat(String(v).replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function mustFix(p){
    var sortBy = p.get('sort_by');
    var gte = toNum(p.get('filter.v.price.gte'));
    var lte = toNum(p.get('filter.v.price.lte'));
    // condición exacta: descending + gte=59 + lte=100
    return sortBy === 'price-descending' && gte === 59 && lte === 100;
  }

  // Cambia a lte=1000 y RECARGA (evita loop al comprobar sólo cuando lte==100)
  function fixAndReloadIfNeeded() {
    var path = location.pathname.replace(/\/+$/,'');
    if (path !== TARGET_PATH) return;

    var p = new URLSearchParams(location.search);
    if (!mustFix(p)) return;

    p.set('filter.v.price.lte', '1000');
    var newUrl = location.pathname + '?' + p.toString();
    // recarga navegando a la URL corregida
    location.replace(newUrl);
  }

  // Intercepta clicks a enlaces que tengan JUSTO esa query y recarga a la corregida
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href]');
    if (!a) return;
    try {
      var url = new URL(a.href, location.origin);
      if (url.pathname.replace(/\/+$/,'') !== TARGET_PATH) return;
      if (!mustFix(url.searchParams)) return;

      e.preventDefault();
      url.searchParams.set('filter.v.price.lte','1000');
      location.href = url.pathname + '?' + url.searchParams.toString();
    } catch(_) {}
  }, true);

  // Vigila navegación SPA (por si tu tema cambia los params sin recargar)
  (function hookHistory(){
    var _push = history.pushState;
    history.pushState = function() {
      _push.apply(this, arguments);
      setTimeout(fixAndReloadIfNeeded, 0);
    };
    var _replace = history.replaceState;
    history.replaceState = function() {
      _replace.apply(this, arguments);
      setTimeout(fixAndReloadIfNeeded, 0);
    };
    window.addEventListener('popstate', function(){ setTimeout(fixAndReloadIfNeeded, 0); });
  })();

  // Primera comprobación al cargar
  fixAndReloadIfNeeded();
})();

(function () {
  var TARGET_PATH = '/collections/bags';

  // "59", "59.00", "59,00" -> 59
  function toNum(v){
    if (v == null) return null;
    var n = parseFloat(String(v).replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  // Aplica reglas y devuelve una URL de destino si hay cambios; si no, null
  function getFixedUrlIfNeeded(url) {
    var path = url.pathname.replace(/\/+$/,'');
    if (path !== TARGET_PATH) return null;

    var p = url.searchParams;
    var sortBy = p.get('sort_by');
    var gte = toNum(p.get('filter.v.price.gte'));
    var lte = toNum(p.get('filter.v.price.lte'));

    // Regla 1: descending + 59–100  -> 59–1000
    if (sortBy === 'price-descending' && gte === 59 && lte === 100) {
      p.set('filter.v.price.lte', '1000');
      return path + '?' + p.toString();
    }

    // Regla 2: ascending + 75–100  -> 59–1000
    if (sortBy === 'price-ascending' && gte === 75 && lte === 100) {
      p.set('filter.v.price.gte', '59');
      p.set('filter.v.price.lte', '1000');
      return path + '?' + p.toString();
    }

    return null;
  }

  function fixAndReloadIfNeeded() {
    var current = new URL(location.href);
    var fixed = getFixedUrlIfNeeded(current);
    if (fixed && (location.pathname + location.search) !== fixed) {
      // Evita bucles porque tras fijar ya no coinciden las condiciones
      location.replace(fixed);
    }
  }

  // Intercepta clicks y corrige el href antes de navegar
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href]');
    if (!a) return;
    try {
      var url = new URL(a.href, location.origin);
      var fixed = getFixedUrlIfNeeded(url);
      if (fixed) {
        e.preventDefault();
        location.href = fixed; // navega ya corregido (recarga)
      }
    } catch(_) {}
  }, true);

  // Vigila navegación SPA (pushState/replaceState/popstate)
  (function hookHistory(){
    var _push = history.pushState;
    history.pushState = function() {
      _push.apply(this, arguments);
      setTimeout(fixAndReloadIfNeeded, 0);
    };
    var _replace = history.replaceState;
    history.replaceState = function() {
      _replace.apply(this, arguments);
      setTimeout(fixAndReloadIfNeeded, 0);
    };
    window.addEventListener('popstate', function(){ setTimeout(fixAndReloadIfNeeded, 0); });
  })();

  // Primera pasada al cargar
  fixAndReloadIfNeeded();
})();








// all products


(function () {
  var TARGET_PATH = '/collections/all-products';

  // Normaliza "65", "65.0", "65,00" -> 65
  function toNum(v){
    if (v == null) return null;
    var n = parseFloat(String(v).replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  // Devuelve URL corregida si lte=65; en otro caso, null
  function getFixedUrlIfNeeded(url) {
    var path = url.pathname.replace(/\/+$/,'');
    if (path !== TARGET_PATH) return null;

    var p = url.searchParams;
    var lte = toNum(p.get('filter.v.price.lte'));

    // Regla: si lte==65 -> forzar gte=0 y lte=1000
    if (lte === 65) {
      p.set('filter.v.price.gte', '0');
      p.set('filter.v.price.lte', '1000');
      return path + '?' + p.toString();
    }
    return null;
  }

  function fixAndReloadIfNeeded() {
    var cur = new URL(location.href);
    var fixed = getFixedUrlIfNeeded(cur);
    if (fixed && (location.pathname + location.search) !== fixed) {
      location.replace(fixed); // recarga a la URL corregida
    }
  }

  // Corrige al cargar
  fixAndReloadIfNeeded();

  // Intercepta enlaces y navega a la versión corregida (con recarga)
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href]');
    if (!a) return;
    try {
      var url = new URL(a.href, location.origin);
      var fixed = getFixedUrlIfNeeded(url);
      if (fixed) { e.preventDefault(); location.href = fixed; }
    } catch(_) {}
  }, true);

  // Vigila navegación SPA (push/replace/pop)
  (function hookHistory(){
    var _push = history.pushState, _replace = history.replaceState;
    history.pushState = function(){ _push.apply(this, arguments); setTimeout(fixAndReloadIfNeeded,0); };
    history.replaceState = function(){ _replace.apply(this, arguments); setTimeout(fixAndReloadIfNeeded,0); };
    addEventListener('popstate', function(){ setTimeout(fixAndReloadIfNeeded,0); });
  })();
})();





